// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rr7q","title":"styles_title__36J3I"};